import { ERROR_MESSAGES, type ConversationKind, type ErrorCode, type MetaFailure } from '@rp/contracts'
import { CODE_FAILURE_COPY, DM_UNCONFIRMED_FAILURE, FAILURE_COPY, SERVER_MESSAGE_CODES, heldByOtherFailure } from './copy'

export type FailureGuidance = {
  title: string
  nextStep: string
  actionLabel: string | null
  actionKind: 'retry' | 'reconnect' | null
}

const carriesServerMessage = (code: ErrorCode): boolean =>
  (SERVER_MESSAGE_CODES as readonly ErrorCode[]).includes(code)

const saysNothingSpecific = (code: ErrorCode, message: string): boolean => message === ERROR_MESSAGES[code]

const codeGuidance = (code: ErrorCode, message: string | null): FailureGuidance | null => {
  if (!(code in CODE_FAILURE_COPY)) return null
  const copy = CODE_FAILURE_COPY[code as keyof typeof CODE_FAILURE_COPY]
  if (message === null || !carriesServerMessage(code) || saysNothingSpecific(code, message)) return copy
  return { ...copy, nextStep: message }
}

export const failureGuidance = (
  failure: MetaFailure | null,
  code: ErrorCode | null,
  message: string | null = null,
  holder: string | null = null,
): FailureGuidance => {
  if (code === 'CLAIM_HELD_BY_OTHER' && holder !== null) return heldByOtherFailure(holder)
  const byCode = code === null ? null : codeGuidance(code, message)
  if (byCode !== null) return byCode
  if (failure !== null) return FAILURE_COPY[failure.reason]
  if (code === 'UPSTREAM_UNAVAILABLE') return FAILURE_COPY.unavailable
  return FAILURE_COPY.unknown
}

const MAYBE_DELIVERED: readonly FailureGuidance[] = [FAILURE_COPY.unavailable]

export const guidanceForKind = (guidance: FailureGuidance, kind: ConversationKind): FailureGuidance =>
  kind === 'dm' && MAYBE_DELIVERED.includes(guidance) ? DM_UNCONFIRMED_FAILURE : guidance
